<template>
  <!--    移动端汉堡导航菜单-->
  <div class="mobile-menu-sidebar" :style="show? 'left:0':'left: -100%'"
  :class="[isFooterMenu? 'footer-menu' : '']"
  >

    <div class="mobile-menu-content">
      <div class="mobile-menu-list">
        <div
            class="mobile-menu-item"
            v-for="item in menuList"
            :key="item.path">

          <!-- 一级菜单项 -->
          <div
              class="mobile-menu-link"
              :class="{
                active: isMenuActive(item),
                'has-children': item.children && item.children.length > 0
              }"
              @click="handleMobileMenuClick(item)">

            <router-link
                v-if="!item.children || item.children.length === 0"
                :to="item.path"
                :class="{active: isActive(item.path)}"
                class="mobile-link-text">
              {{ item.meta.title }}
            </router-link>

            <div v-else class="mobile-link-text">
              {{ item.meta.title }}
              <i class="el-icon-arrow-down"
                 :class="{ rotated: isExpanded(item.path) }"></i>
            </div>
          </div>

          <!-- 二级菜单（移动端） -->
          <div
              class="mobile-submenu"
              v-if="item.children && item.children.length > 0"
              :class="{ expanded: isExpanded(item.path) }">

            <div
                class="mobile-submenu-item"
                v-for="child in item.children"
                :key="child.path">

              <div
                  class="mobile-submenu-link"
                  :class="{
                    active: isActive(child.path) || isAncestorOfActiveMenu(child),
                    'has-children': child.children && child.children.length > 0
                  }"
                  @click="handleMobileSubmenuClick(child, item.path)">

                <router-link
                    v-if="!child.children || child.children.length === 0"
                    :to="child.path"
                    class="mobile-submenu-text">
                  {{ child.meta.title }}
                </router-link>

                <div v-else class="mobile-submenu-text">
                  {{ child.meta.title }}
                  <i class="el-icon-arrow-down"
                     :class="{ rotated: isExpanded(child.path) }"></i>
                </div>
              </div>

              <!-- 三级菜单（移动端） -->
              <div
                  class="mobile-thirdmenu"
                  v-if="child.children && child.children.length > 0"
                  :class="{ expanded: isExpanded(child.path) }">

                <div
                    class="mobile-thirdmenu-item"
                    v-for="grandchild in child.children"
                    :key="grandchild.path">

                  <div
                      class="mobile-thirdmenu-link"
                      :class="{
                        active: isActive(grandchild.path) || isAncestorOfActiveMenu(grandchild),
                        'has-children': grandchild.children && grandchild.children.length > 0
                      }"
                      @click="handleMobileThirdmenuClick(grandchild, child.path)">

                    <router-link
                        v-if="!grandchild.children || grandchild.children.length === 0"
                        :to="grandchild.path"
                        class="mobile-thirdmenu-text">
                      {{ grandchild.meta.title }}
                    </router-link>

                    <div v-else class="mobile-thirdmenu-text">
                      {{ grandchild.meta.title }}
                      <i class="el-icon-arrow-down"
                         :class="{ rotated: isExpanded(grandchild.path) }"></i>
                    </div>
                  </div>

                  <!-- 四级菜单（移动端） -->
                  <div
                      class="mobile-fourthmenu"
                      v-if="grandchild.children && grandchild.children.length > 0"
                      :class="{ expanded: isExpanded(grandchild.path) }">

                    <router-link
                        v-for="greatGrandchild in grandchild.children"
                        :key="greatGrandchild.path"
                        :to="greatGrandchild.path"
                        class="mobile-fourthmenu-item"
                        :class="{ active: isActive(greatGrandchild.path) || isAncestorOfActiveMenu(greatGrandchild) }"
                        @click.native="handleMobileFourthmenuClick(greatGrandchild)">

                      <div class="mobile-fourthmenu-text">
                        {{ greatGrandchild.meta.title }}
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mobile-menu-item" @click="changeLanguage">
          <div class="mobile-menu-link">
            <div class="mobile-link-text">
              {{ langZh ? 'English' : '中文' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {changeLanguage} from '@/api'

export default {
  props: {
    menuShow: {
      type: Boolean,
      default: false
    },
    isFooterMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      expandedPaths: [], // 跟踪展开的路径
      menuList: [
        {
          path: '/index',
          name: 'Index',
          meta: {title: this.$t('dashboard')}
        },
        //关于乾景
        {
          path: '/about',
          name: 'About',
          meta: {title: this.$t('title-guan-yu-qian-jing')}//'关于乾景'

        },     //产品与服务
        {

          path: '/productService',
          name: 'productService',
          meta: {title: this.$t('chan-pin-yu-fu-wu')},
          children: [
            {
              name: 'Product',
              path: '/productService/product',
              meta: {title: this.$t('chan-pin')},
              children: [
                {
                  name: 'Lifting',
                  path: '/productService/product/lifting',
                  meta: {title: this.$t('ren-gong-ju-sheng-xi-tong')},
                  children: [
                    {
                      name: 'ElectricPump',
                      path: '/productService/product/lifting/electricPump',
                      meta: {title: this.$t('dian-qian-luo-gan-beng')},
                    }
                  ]
                },
                {
                  name: 'Support',
                  path: '/productService/product/support',
                  meta: {title: this.$t('pei-tao-fu-jian')},
                },
                {
                  name: 'Energy',
                  path: '/productService/product/energy',
                  meta: {title: this.$t('neng-yuan-fang-an')},
                },
              ]
            },
            {
              name: 'Service',
              path: '/productService/service',
              meta: {title: this.$t('fu-wu')},
              children: [
                {
                  name: 'Application',
                  path: '/productService/service/application',
                  meta: {title: this.$t('ying-yong-fang-an')},
                },
                {
                  name: 'Service',
                  path: '/productService/service/service',
                  meta: {title: this.$t('fu-wu')},
                },
              ]
            }
          ]
        },
        //可持续发展
        {

          path: '/develop',
          name: 'Develop',
          meta: {title: this.$t('title-ke-chi-xu-fa-zhan')}
        },
        //新闻中心
        {
          path: '/news',
          name: 'News',
          meta: {title: this.$t('title-xin-wen-zhong-xin')}
        },
        {
          path: '/news/detail/:id/',
          name: 'NewsDetail',
          hidden: true,
          meta: {title: this.$t('xin-wen-xiang-qing')}
        },
        //联系我们
        {
          path: '/contact',
          name: 'Contact',
          meta: {title: this.$t('title-lian-xi-wo-men')}
        }
      ]
    }
  },

  mounted() {
    //  筛选菜单hidden不为true的菜单项
    this.menuList = this.menuList.filter(item => !item.hidden)
    // 初始化时根据当前路由设置激活状态
    this.updateActiveFromRoute(this.$route)
    // 根据当前路由自动展开相关菜单
    this.autoExpandCurrentRoute()
  },

  computed: {
    ...mapGetters([
      'activeMenuItems',
      'breadcrumbPath',
      'isMobileMenuOpen'
    ]),
    langZh() {
      return sessionStorage.getItem('lang') === 'zh_CN'
    },
  },
  methods: {
    changeLanguage() {
      let key = this.langZh ? 'en' : 'zh_CN'
      this.$i18n.locale = key
      sessionStorage.setItem('lang', key)
      this.$emit('changeLang', key)
      if (key === 'en') {
        changeLanguage('en_US')
      } else {
        changeLanguage('zh_CN')
      }
      location.reload()
    },
    ...mapActions([
      'updateActiveMenuItem',
      'updateActiveFromRoute',
      'clearActiveMenuItems'
    ]),
    closeMobileMenu() {
      this.$emit('closeMobileMenu')
    },

    // 判断路径是否已展开
    isExpanded(path) {
      return this.expandedPaths.includes(path);
    },

    // 切换展开状态
    toggleExpand(path) {
      const index = this.expandedPaths.indexOf(path);
      if (index > -1) {
        this.expandedPaths.splice(index, 1);
      } else {
        this.expandedPaths.push(path);
      }
    },

    // 自动展开当前路由对应的菜单
    autoExpandCurrentRoute() {
      const currentPath = this.$route.path;
      this.expandedPaths = []; // 清空之前的状态
      this.findAndExpandParentPaths(currentPath, this.menuList);
    },

    // 查找并展开指定路径的所有父级菜单
    findAndExpandParentPaths(path, menus, currentPath = '') {
      for (const menu of menus) {
        // 使用更精确的路径匹配逻辑
        const fullPath = menu.path.startsWith('/') ? menu.path : `/${menu.path}`;

        if (path === fullPath || path.startsWith(fullPath + '/') ||
            (fullPath.startsWith(path) && fullPath.split('/').length > path.split('/').length)) {

          // 如果当前菜单包含当前路由路径或当前路由是其父路径，则展开它
          if (menu.children && menu.children.length > 0) {
            if (!this.expandedPaths.includes(menu.path)) {
              this.expandedPaths.push(menu.path);
            }

            // 继续在子菜单中查找
            this.findAndExpandParentPaths(path, menu.children, fullPath);
          }
        }
      }
    },

    // 处理移动端菜单点击
    handleMobileMenuClick(menuItem) {
      if (menuItem.children && menuItem.children.length > 0) {
        // 有子菜单，切换展开状态
        this.toggleExpand(menuItem.path);
      } else {
        // 没有子菜单，直接跳转
        this.$router.push(menuItem.path)
        this.updateActiveMenuItem({
          level: 'level1',
          item: {
            path: menuItem.path,
            title: menuItem.meta.title
          }
        })
        this.closeMobileMenu()
      }
    },

    // 处理移动端子菜单点击
    handleMobileSubmenuClick(menuItem, parentPath) {
      if (menuItem.children && menuItem.children.length > 0) {
        // 有子菜单，切换展开状态
        this.toggleExpand(menuItem.path);
      } else {
        // 没有子菜单，直接跳转
        this.$router.push(menuItem.path)
        // 找到父级菜单
        const parentItem = this.findMenuByPath(parentPath)
        if (parentItem) {
          this.updateActiveMenuItem({
            level: 'level1',
            item: {
              path: parentItem.path,
              title: parentItem.meta.title
            }
          })
        }
        this.updateActiveMenuItem({
          level: 'level2',
          item: {
            path: menuItem.path,
            title: menuItem.meta.title
          }
        })
        this.closeMobileMenu()
      }
    },

    // 处理移动端三级菜单点击
    handleMobileThirdmenuClick(menuItem, parentPath) {
      if (menuItem.children && menuItem.children.length > 0) {
        // 有子菜单，切换展开状态
        this.toggleExpand(menuItem.path);
      } else {
        // 没有子菜单，直接跳转
        this.$router.push(menuItem.path)
        // 找到父级和祖父级菜单
        const parentItem = this.findMenuByPath(parentPath)
        const grandParentItem = parentItem ? this.findParentMenu(parentItem.path) : null

        if (grandParentItem) {
          this.updateActiveMenuItem({
            level: 'level1',
            item: {
              path: grandParentItem.path,
              title: grandParentItem.meta.title
            }
          })
        }
        if (parentItem) {
          this.updateActiveMenuItem({
            level: 'level2',
            item: {
              path: parentItem.path,
              title: parentItem.meta.title
            }
          })
        }
        this.updateActiveMenuItem({
          level: 'level3',
          item: {
            path: menuItem.path,
            title: menuItem.meta.title
          }
        })
        this.closeMobileMenu()
      }
    },

    // 处理移动端四级菜单点击
    handleMobileFourthmenuClick(menuItem) {
      this.$router.push(menuItem.path)
      // 这里需要递归找到所有父级菜单
      this.updateActiveFromRoute(this.$route)
      this.closeMobileMenu()
    },

    // 根据路径查找菜单
    findMenuByPath(path, menus = this.menuList) {
      for (const menu of menus) {
        if (menu.path === path) {
          return menu
        }
        if (menu.children) {
          const found = this.findMenuByPath(path, menu.children)
          if (found) return found
        }
      }
      return null
    },

    // 查找父级菜单
    findParentMenu(childPath, menus = this.menuList, parent = null) {
      for (const menu of menus) {
        if (menu.path === childPath) {
          return parent
        }
        if (menu.children) {
          const found = this.findParentMenu(childPath, menu.children, menu)
          if (found) return found
        }
      }
      return null
    },

    isActive(path) {
      return this.$route.path === path
    },

    // 检查菜单项是否是当前激活路由的祖先节点
    isAncestorOfActiveMenu(menuItem) {
      // 遍历当前路由，看是否有子路径匹配
      const currentPath = this.$route.path;

      // 检查当前菜单项是否是当前路径的祖先
      if (menuItem.children && menuItem.children.length > 0) {
        for (const child of menuItem.children) {
          if (currentPath.startsWith(child.path) || this.isAncestorOfActiveMenuWithChildren(child, currentPath)) {
            return true;
          }
        }
      }
      return false;
    },

    // 辅助函数，递归检查深层子菜单
    isAncestorOfActiveMenuWithChildren(menuItem, currentPath) {
      if (this.isActive(menuItem.path) || currentPath.startsWith(menuItem.path)) {
        return true;
      }

      if (menuItem.children) {
        for (const child of menuItem.children) {
          if (this.isAncestorOfActiveMenuWithChildren(child, currentPath)) {
            return true;
          }
        }
      }

      return false;
    },

    // 检查菜单项是否激活或其子项中有激活的
    isMenuActive(menuItem) {
      // 如果当前菜单项本身就是激活的
      if (this.isActive(menuItem.path)) {
        return true;
      }

      // 如果当前菜单项的任何后代是激活的，则当前菜单项也应显示为激活
      if (menuItem.children) {
        return this.hasActiveDescendant(menuItem, this.$route.path);
      }

      return false;
    },

    // 检查菜单项是否有激活的后代
    hasActiveDescendant(menuItem, currentPath) {
      if (!menuItem.children) {
        return false;
      }

      for (const child of menuItem.children) {
        if (currentPath.startsWith(child.path)) {
          return true;
        }

        if (child.children) {
          if (this.hasActiveDescendant(child, currentPath)) {
            return true;
          }
        }
      }

      return false;
    }
  },

  watch: {
    // 监听路由变化，更新激活状态
    '$route'(to, from) {
      this.updateActiveFromRoute(to)
      // 路由变化时重新计算展开状态
      this.autoExpandCurrentRoute();
    },
    menuShow: {
      handler(val) {
        if (val) {
          // 当菜单显示时，确保当前路由相关的菜单项展开
          this.autoExpandCurrentRoute();
        }
        this.show = val
      },
      immediate: true
    },
  },
}
</script>

<style scoped lang="scss">
.footer-menu{
  position:relative!important;
  z-index:0!important;
  height: fit-content!important;
  box-shadow: none!important;
  top: 0!important;
}

/* 移动端菜单侧边栏 */
.mobile-menu-sidebar {
  display: flex;
  position: fixed;
  top: 80px;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: left 0.3s ease;
  overflow-y: auto;
}

.mobile-menu-content {
  padding: 16px 20px;
}

.mobile-menu-list {
  padding: 0;
}

.mobile-menu-item {
  padding: 12px 0;
  border-bottom: 1px solid #EEEEEE;
}

.mobile-menu-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.mobile-menu-link.active {
  .mobile-link-text {
    color: #1C277F;
    font-family: Alibaba-PuHuiTi-Medium;
  }
}

.mobile-menu-link:hover {
  .mobile-link-text {
    color: #1C277F;
  }
}

.mobile-link-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  text-decoration: none;
  color: #333;
  text-align: right;
  font-family: "Alibaba PuHuiTi";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.mobile-link-text i {
  font-size: 16px;
  transition: transform 0.3s;
}

.mobile-link-text i.rotated {
  transform: rotate(180deg);
  color: #1C277F;
  font-weight: bold;
}

/* 移动端子菜单 */
.mobile-submenu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.mobile-submenu.expanded {
  max-height: 1000px;
}

.mobile-submenu-item {
  padding: 14px 0 14px 20px;

  border-bottom: 1px solid #EEEEEE;

  &:last-child {
    padding: 14px 0 0 20px;

    border-bottom: none;
  }
}

.mobile-submenu-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;

}

.mobile-submenu-link.active {
  .mobile-submenu-text {
    color: #1C277F;
    font-family: Alibaba-PuHuiTi-Medium;
  }
}

.mobile-submenu-link:hover {
  .mobile-submenu-text {
    color: #1C277F;
  }
}

.mobile-submenu-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  text-decoration: none;
  color: #333;
  text-align: center;
  font-family: "Alibaba PuHuiTi";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.mobile-submenu-text i {
  font-size: 16px;
  transition: transform 0.3s;
}

.mobile-submenu-text i.rotated {
  transform: rotate(180deg);
  color: #1C277F;
  font-weight: bold;
}

/* 移动端三级菜单 */
.mobile-thirdmenu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.mobile-thirdmenu.expanded {
  max-height: 1000px;
}

.mobile-thirdmenu-item {
  //border-bottom: 1px solid #e0e0e0;
  padding: 12px 0 0 18px;

}

.mobile-thirdmenu-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.mobile-thirdmenu-link.active {
  .mobile-thirdmenu-text {
    color: #1C277F;
    font-family: Alibaba-PuHuiTi-Medium;
  }
}

.mobile-thirdmenu-link:hover {
  .mobile-thirdmenu-text {
    color: #1C277F;
  }
}

.mobile-thirdmenu-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: #666;
  text-decoration: none;
  text-align: center;
  font-family: "Alibaba PuHuiTi";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.mobile-thirdmenu-text i {
  font-size: 16px;
  transition: transform 0.3s;
}

.mobile-thirdmenu-text i.rotated {
  transform: rotate(180deg);
  color: #1C277F;
  font-weight: bold;
}

/* 移动端四级菜单 */
.mobile-fourthmenu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.mobile-fourthmenu.expanded {
  max-height: 1000px;
}

.mobile-fourthmenu-item {
  padding: 14px 0 0 25px;
  display: block;
  cursor: pointer;
  transition: background-color 0.3s;
  //border-bottom: 1px solid #ddd;
  text-decoration: none;
}

.mobile-fourthmenu-item.active {
  .mobile-fourthmenu-text {
    color: #1C277F;
    font-family: Alibaba-PuHuiTi-Medium;
  }
}

.mobile-fourthmenu-item:hover {
  .mobile-fourthmenu-text {
    color: #1C277F;
  }
}

.mobile-fourthmenu-text {
  color: #666;
  text-align: left;
  font-family: "Alibaba PuHuiTi";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/* 平板设备 (1024px - 1024px) */
@media screen and (max-width: 1024px) {

  .mobile-menu-toggle {
    display: block;
  }

  .more-btn {
    display: none;
  }

  .mobile-menu-overlay {
    display: block;
  }

  .mobile-menu-sidebar {
    display: block;
  }

  .dropdown-container {
    flex-direction: column;
    padding: 0;
  }

  .dropdown-column {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #f0f0f0;
    padding: 20px;
  }

  .dropdown-content-right {
    display: none;
  }
}

/* 横屏模式适配 */
@media screen and (max-height: 500px) and (orientation: landscape) {
  .mobile-menu-sidebar {
    width: 60%;
    max-width: 400px;
  }

  .mobile-menu-content {
    max-height: calc(100vh - 60px);
    overflow-y: auto;
  }
}

</style>
